export default __webpack_public_path__ + "static/media/LinkBlack.12868efa.svg";